<template>
  <div class="box">
    <el-tabs
      type="border-card"
      v-model="activeName"
    >
      <el-tab-pane
        label="结算单详情"
        class="tab"
        name="first"
      >
        <div>
          <ul class="header">
            <li>状态：<span style="color:red;">{{status}}</span></li>
            <li>结算编号：<span>{{serialNum}}</span></li>
            <li>申请时间：<span>{{createdAt}}</span></li>
            <li>结算金额：<span style="color:red;">{{settleMoney}}</span></li>
          </ul>
          <div
            class="title"
            style="padding-bottom: 10px"
          >基本信息</div>
          <div
            class="title"
            style="color: #333333"
          >商店名称：{{businessName}}<span style="color: #999999">（id:{{businessId}}）</span>
          </div>
          <ul>
            <li>提现方式：{{settleTypeStr}}</li>
            <li>收款人：{{collectName}}</li>
            <li>收款银行：{{collectBank}}</li>
            <li>银行卡号：{{collectAccount}}</li>
          </ul>
          <div class="title">结算周期</div>
          <ul>
            <li>资金托管方：{{financialSourceName}}</li>
            <li>结算周期：{{settleCycle}}</li>
          </ul>
        </div>
      </el-tab-pane>
      <el-tab-pane
        label="结算明细"
        class="tab"
        name="second"
      >
        <div class="title">结算周期</div>
        <ul style="padding-bottom: 30px">
          <div style="display: flex">
            <li>资金托管方：{{financialSourceName}}</li>
            <li>结算周期：{{settleCycle}}</li>
          </div>
          <el-button type="warning" @click="exportExcel" class="_right" :loading="exportLoad">导出excel</el-button>
        </ul>
        <el-table
          :data="billList"
          v-loading="loading"
          border
          min-height="200"
          max-height="700"
        >
          <!-- <el-table-column fixed :label="statusTitle"> -->
          <el-table-column
            fixed
            label="订单号"
            align="center"
            prop="serialNum"
            width="280"
          ></el-table-column>
          <el-table-column
            label="用户"
            align="center"
            prop="businessId"
            width="220"
          >
            <template slot-scope="scope">
              <span v-if='scope.row.memberName===""||scope.row.memberName==null'></span>
              <span v-if='scope.row.memberName!==null&&scope.row.memberName!==""'>{{scope.row.memberName}}({{scope.row.memberPhone}})</span>
            </template>
          </el-table-column>
          <el-table-column
            label="所在单位"
            show-overflow-tooltip
            align="center"
            prop="governmentName"
            width="180"
          ></el-table-column>
          <el-table-column
            label="订单金额"
            align="center"
            prop="money"
            width="100"
          ></el-table-column>
          <el-table-column
            label="退款"
            align="center"
            prop="refundMoney"
            width="100"
          >
          </el-table-column>
          <el-table-column
            label="实收金额"
            align="center"
            width="100"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.type=='10'"
                style="color: red"
              >{{scope.row.receiveMoneyStr}}</span>
              <span v-if="scope.row.type=='20'"></span>
            </template>
          </el-table-column>
          <el-table-column
            label="服务费"
            align="center"
            prop="taxMoneyStr"
            width="100"
          ></el-table-column>
          <el-table-column
            label="订单类型"
            align="center"
            prop="orderTypeStr"
            width="150"
          ></el-table-column>
          <el-table-column
            label="支付方式"
            align="center"
            prop="paySourceStr"
            width="150"
          ></el-table-column>
          <el-table-column
            label="下单时间"
            align="center"
            prop="createdAt3"
            width="180"
          ></el-table-column>
          <el-table-column
            label="可结算时间"
            align="center"
            prop="ableSettleAtStr"
            width="180"
          ></el-table-column>
          <!-- </el-table-column> -->
        </el-table>
        <div style="display: flex;justify-content: space-between">
          <div class="current-total-money"></div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="limit"
            layout="sizes, prev, pager, next, jumper"
            :total="total"
            background
            style="margin-top: 20px"
          >
          </el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
// import getDetail from "@/api"
import { getDetail, getOrderlist, GetExcel } from "@/api";

export default {
  name: "detail",
  data() {
    return {
      activeName: "first",
      status: "",
      serialNum: "",
      createdAt: "",
      settleMoney: "",
      businessName: "",
      businessId: "",
      settleTypeStr: "",
      financialSourceName: "",
      settleCycle: "",
      billList: [],
      settleId: "",
      loading: false,
      collectBank: "",
      collectAccount: "",
      collectName: "",
      page: 1,
      limit: 10,
      total: 1,
      exportLoad: false,
    };
  },

  created() {
    // this.id=this.$router.params.id
    this.settleId = this.$route.query.id;
    this.getDetail();
    this.getOrderlist();
  },
  methods: {
    // handleClick(tab, event) {
    //     // console.log(tab, event);
    // },
    //获取结算金额
    async getDetail() {
      const data = await getDetail(this.settleId);
      this.status = data.data.statusStr;
      this.serialNum = data.data.serialNum;
      this.createdAt = data.data.createdAt;
      this.settleMoney = data.data.settleMoney;
      this.businessName = data.data.businessName;
      this.businessId = data.data.businessId;
      this.settleTypeStr = data.data.settleTypeStr;
      this.settleByStr = data.data.settleByStr;
      this.collectBank = data.data.collectBank;
      this.collectAccount = data.data.collectAccount;
      this.collectName = data.data.collectName;
      this.financialSourceName = data.data.financialSourceName;
      this.settleCycle = data.data.settleCycle;
    },

    // 每页条数改变时
    handleSizeChange(val) {
      this.limit = val;
      this.getOrderlist();
    },
    // 当前页数改变时
    handleCurrentChange(val) {
      this.page = val;
      this.getOrderlist();
    },

    //获取结算订单列表
    async getOrderlist() {
      this.loading = true;
      let params = {
        pageSize: this.limit,
        pageIndex: this.page,
      };
      const data = await getOrderlist(this.settleId, params);
      // console.log(data)
      // console.log(data)
      // if(){

      // }
      this.billList = data.data.items;
      this.total = Number(data.data.elementCount)
      this.loading = false;
    },
    //下载exlce
    async exportExcel() {
      // this.exportLoad = true;
      // let obj = {
      //   limit: this.limit,
      //   page: this.page,
      // };
      const data = await GetExcel(this.settleId);
      this.exportLoad = false;
      if (!data) {
        this.$message.error("下载模板文件失败");
        this.exportLoad = false;
        return false;
      }
    },
    
  },
};
</script>
<style scoped>
.box {
  min-height: 88%;
}

.tab {
  height: 620px;
  overflow-y: auto;
}

template {
  font-size: 16px;
  color: #333333;
}

ul {
  font-size: 16px;
  display: flex;
  justify-content: space-between;
  color: #333333;
  padding: 10px 0;
  align-items: center;
  /*position: relative;*/
}

li {
  padding-right: 110px;
}

.title {
  font-size: 16px;
  padding: 30px 0px;
  color: #41a3ff;
}

.header {
  padding-top: 30px;
  color: #333333;
}
._color {
  color: red;
}
._right {
  float: right;
}
</style>